import {
  ElementsSvg,
  FolderSvg,
  ImageSvg,
  LanguageIcon,
  TemplateSvg,
  MasterElementsSvg,
  ComplexDesignSvg,
  businessLogicSvg,
  PreviewIcon,
  channelIcon,
} from '../../components/SidebarMenuIcons';
import { BUSINESS_LOGIC_TAB, COMPLEX_DOC_SIDEBAR } from './translationValues';
import { DESIGN_AREA_SIDEBAR_MENUS } from '../SidebarMenu/translationValues';
import { AccessibilitySvgIcon } from '../../images/svgIcons';

const tabsNotNeededForInteractiveDesign = [11, 7, 9, 14, 15];
const tabsNotNeededForOpenDesign = [11, 12, 7, 14]

export const ComplexDesignTabs = (t, currentDesign, isInteractiveDesign, isDesigner, isOpenDesign) => {

  const tabs = [
    {
      id: 2,
      label: t(COMPLEX_DOC_SIDEBAR.LETS_DESIGN_TAB_TOOLTIP.key, COMPLEX_DOC_SIDEBAR.LETS_DESIGN_TAB_TOOLTIP.value),
      icon: ComplexDesignSvg,
      className: undefined
    },
    {
      id: 11,
      label: t(`DESIGN_AREA_SIDEBAR_MENUS:${DESIGN_AREA_SIDEBAR_MENUS.TEMPLATES_TAB_TOOLTIP.key}`, DESIGN_AREA_SIDEBAR_MENUS.TEMPLATES_TAB_TOOLTIP.value),
      icon: TemplateSvg,
      className: undefined,
    },
    {
      id: 12,
      label: t(`DESIGN_AREA_SIDEBAR_MENUS:${DESIGN_AREA_SIDEBAR_MENUS.ELEMENTS_TAB_TOOLTIP.key}`, DESIGN_AREA_SIDEBAR_MENUS.ELEMENTS_TAB_TOOLTIP.value),
      icon: ElementsSvg,
      className: undefined,
    },
    {
      id: 7,
      label: t(`DESIGN_AREA_SIDEBAR_MENUS:${DESIGN_AREA_SIDEBAR_MENUS.FOLDERS_TAB_TOOLTIP.key}`, DESIGN_AREA_SIDEBAR_MENUS.FOLDERS_TAB_TOOLTIP.value),
      icon: FolderSvg,
      className: undefined,
    },
    {
      id: 8,
      label: t(COMPLEX_DOC_SIDEBAR.SETTINGS_TAB_TOOLTIP.key, COMPLEX_DOC_SIDEBAR.SETTINGS_TAB_TOOLTIP.value),
      type: 'setting',
      className: 'settings-icon',
    },
    ...currentDesign !== 'document' ? [{
      id: 9,
      label: t(`DESIGN_AREA_SIDEBAR_MENUS:${DESIGN_AREA_SIDEBAR_MENUS.TRANSLATE_TAB_TOOLTIP.key}`, DESIGN_AREA_SIDEBAR_MENUS.TRANSLATE_TAB_TOOLTIP.value),
      icon: LanguageIcon,
      className: 'settings-icon',      
    }]: [],
    ...currentDesign === 'document' ? [{
       id: 14,
       label: t(`DESIGN_AREA_SIDEBAR_MENUS:${DESIGN_AREA_SIDEBAR_MENUS.CHANNEL_TOOLTIP.key}`, DESIGN_AREA_SIDEBAR_MENUS.CHANNEL_TOOLTIP.value),
       icon: channelIcon,
       className: 'channel-icon',
     }] : [],
    ...currentDesign === 'document' ?
      [{
        id: 13,
        label: t(BUSINESS_LOGIC_TAB.BUSINESS_LOGIC_LABEL.key, BUSINESS_LOGIC_TAB.BUSINESS_LOGIC_LABEL.value),
        icon: businessLogicSvg,
        className: 'business-logic'
      }] : [],
    {
      id: 15,
      label: t(`DESIGN_AREA_SIDEBAR_MENUS:${DESIGN_AREA_SIDEBAR_MENUS.ACCESSIBILITY_DESIGN.key}`, DESIGN_AREA_SIDEBAR_MENUS.ACCESSIBILITY_DESIGN.value),
      icon: AccessibilitySvgIcon,
      className: 'accessibility-design'
    },
    {
      id: 10,
      label: isInteractiveDesign
        ? t(`DESIGN_AREA_SIDEBAR_MENUS:${DESIGN_AREA_SIDEBAR_MENUS.PREVIEW_DOWNLOAD_TOOLTIP.key}`, DESIGN_AREA_SIDEBAR_MENUS.PREVIEW_DOWNLOAD_TOOLTIP.value)
        : isDesigner
          ? t(`DESIGN_AREA_SIDEBAR_MENUS:${DESIGN_AREA_SIDEBAR_MENUS.PREVIEW_DOWNLOAD_TOOLTIP.key}`, DESIGN_AREA_SIDEBAR_MENUS.PREVIEW_DOWNLOAD_TOOLTIP.value)
          : t(`DESIGN_AREA_SIDEBAR_MENUS:${DESIGN_AREA_SIDEBAR_MENUS.PREVIEW_TOOLTIP.key}`, DESIGN_AREA_SIDEBAR_MENUS.PREVIEW_TOOLTIP.value),
      icon: PreviewIcon,
      className: 'business-logic'
    },
  ];

  if (isInteractiveDesign) {
    return tabs.filter(v => !tabsNotNeededForInteractiveDesign.includes(v.id));
  }

  if(isOpenDesign) {
    return tabs.filter(v => !tabsNotNeededForOpenDesign.includes(v.id));
  }

  return tabs;
};

export const CreativeDesignTabs = t => [
  {
    id: 6,
    label: t(`DESIGN_AREA_SIDEBAR_MENUS:${DESIGN_AREA_SIDEBAR_MENUS.MASTER_ELEMENTS_TAB_TOOLTIP.key}`, DESIGN_AREA_SIDEBAR_MENUS.MASTER_ELEMENTS_TAB_TOOLTIP.value),
    icon: MasterElementsSvg,
    className: undefined,
  },
  {
    id: 5,
    label: t(`DESIGN_AREA_SIDEBAR_MENUS:${DESIGN_AREA_SIDEBAR_MENUS.UPLOADS_TAB_TOOLTIP.key}`, DESIGN_AREA_SIDEBAR_MENUS.UPLOADS_TAB_TOOLTIP.value),
    icon: ImageSvg,
    className: undefined
  },
]